<template>
    
    <div style="height: 15vh;"></div>
    <center>
        <div class="cc">
        <h3>1. PURPOSE</h3>
        <p>
            These General Terms and Conditions of Sale (GTC) govern the relationship between the site Xsint Intelligence and any person subscribing to a monthly subscription to access the OSINT (Open Source Intelligence) services offered on the platform. These services include access to research tools and open-source intelligence resources, available only during an active subscription period.
        </p>
        
        <h3>2. ACCEPTANCE OF THE GENERAL TERMS AND CONDITIONS OF SALE</h3>
        <p>
            Subscribing to the services implies unconditional acceptance of these GTC. By validating their subscription, the user fully accepts the provisions of the GTC and waives any claim to any other document.
        </p>

        <h3>3. DESCRIPTION OF SERVICES</h3>
        <p>
            The site offers a monthly subscription that provides continuous access to open-source research tools and resources. The services offered are detailed on the platform and are available exclusively to active subscribers.
        </p>

        <h3>4. SUBSCRIPTION TERMS</h3>
        <p>
            <strong>Subscription Duration:</strong> The subscription is taken out for a duration of one month, automatically renewable unless canceled by the Client.
        </p>
        <p>
            <strong>Renewal:</strong> At each monthly expiration, the subscription is automatically renewed unless the user cancels before the renewal date.
        </p>
        <p>
            <strong>Cancellation:</strong> The Client may cancel their subscription at any time via their user account. Cancellation takes effect at the end of the current subscription period and does not entail any refund for the month already started.
        </p>

        <h3>5. EFFECTS OF CANCELLATION</h3>
        <p>
            In case of cancellation of the subscription, the Client immediately loses access to the site's tools and resources at the end of the current period.
        </p>
        <p>
            <strong>Deletion of Searches:</strong> Cancellation results in the permanent deletion of all searches and personal data associated with the subscription. This information will no longer be accessible once the subscription is terminated.
        </p>

        <h3>6. PRICING AND PAYMENT TERMS</h3>
        <p>
            <strong>Subscription Price:</strong> The applicable prices are those displayed on the site at the time of subscription and are indicated in euros, all taxes included (TTC).
        </p>
        <p>
            <strong>Payment:</strong> Payment is required in advance for each one-month subscription period. Payments are made online by credit card via a secure payment system.
        </p>
        <p>
            In case of payment failure or incident, access to the services will be immediately suspended until payment is resolved.
        </p>

        <h3>7. LIABILITY</h3>
        <p>
            The site Xsint Intelligence undertakes to implement all necessary means to ensure quality access to the services provided. However, the site cannot be held responsible for malfunctions related to the internet network or the user's equipment.
        </p>
        <p>
            Information and data obtained through OSINT services are provided for informational purposes only. The Client acknowledges that the use of the data and information obtained is their sole responsibility.
        </p>

        <h3>8. PERSONAL DATA</h3>
        <p>
            Personal data collected during the subscription process is used exclusively for managing the subscription and accessing the services.
        </p>
        <p>
            In accordance with applicable regulations, the Client has the right to access, modify, correct, and delete their personal data by contacting support at contact@xsint-intelligence.com.
        </p>

        <h3>9. MODIFICATION OF THE GENERAL TERMS AND CONDITIONS OF SALE</h3>
        <p>
            The site reserves the right to modify these GTC at any time. The new terms will be communicated to the Client and will take effect for subscriptions renewed after the modification date.
        </p>

        <h3>10. APPLICABLE LAW AND DISPUTES</h3>
        <p>
            These GTC are governed by the applicable law at the company's headquarters. In case of dispute and after a failed attempt at an amicable solution, the competent courts will be those designated by applicable law.
        </p>
    </div>
    </center>
    
</template>

<style scoped>
.cc{
    width: 80%;
    padding: 10px;
    background-color: #111111;
    border-radius: 5px;
    text-align: left
}

h3{
    margin-bottom: 20px
}

p{
    margin-bottom: 15px;    
    font-size: 18px
}
</style>
